<template>
  <div class="dh-container">
    <div class="dh-group">
      <div class="dh-item" v-for="(item, index) in list" :key="index">
        <div class="title" :class="'rank' + (index + 1)">
          TOP{{ index + 1 }}
        </div>
        <div class="rank">分布{{ ['一', '二', '三', '四', '五'][index] }}</div>
        <div
          class="progress"
          :style="{
            border: '1px solid rgba(' + item.color + ', 0.2)',
            backgroundColor: 'rgba(' + item.color + ', 0.1)',
          }"
        >
          <div
            class="child"
            :style="{ backgroundColor: 'rgba(' + item.color + ', 1)' }"
            :ref="'progress' + (index + 1)"
          ></div>
          <div
            class="circle"
            :style="{ backgroundColor: 'rgba(' + item.color + ', 1)' }"
          ></div>
        </div>
        <div class="number" :ref="'number' + (index + 1)">
          {{ item.number }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      list: {
        type: Object,
        default() {
          return {}
        },
      },
    },
    data() {
      return {}
    },
    mounted() {
      this.$nextTick(() => {
        this.init()
      })
    },
    beforeDestroy() {
      let removeArray = []
      this.list.forEach((item, index) => {
        removeArray.push(this.$refs['progress' + (index + 1)])
        removeArray.push(this.$refs['number' + (index + 1)])
      })
      this.$animejs.remove([
        this.$refs.circular,
        this.$refs.number,
        ...removeArray,
      ])
    },
    methods: {
      init() {
        this.list.forEach((item, index) => {
          this.$animejs({
            targets: this.$refs['progress' + (index + 1)],
            easing: 'linear',
            loop: false,
            width: [0, Math.floor((item.number / item.total) * 100) + '%'],
            duration: 500,
          })
          // 数字滚动动画
          this.$animejs({
            targets: this.$refs['number' + (index + 1)],
            innerHTML: [0, item.number],
            cycles: 130,
            round: 1,
            easing: 'linear',
          })
        })
      },
    },
  }
</script>
<style lang="scss" scoped>
  .dh-container {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .dh-group {
      width: 100%;
      .dh-item {
        display: flex;
        align-items: center;
        color: white;
        .title {
          font-size: 14px;
        }
        .rank {
          margin: 0 10px;
          font-size: 14px;
        }
        .progress {
          flex-grow: 1;
          height: 12px;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 0 2px;
          margin: 0.52083vw 0;
          .child {
            height: 4px;
            width: 0%;
          }
          .circle {
            width: 9px;
            height: 9px;
            margin-left: -4px;
            border-radius: 50%;
            box-shadow: 0 0 2px 2px rgba(255, 255, 255, 0.1);
          }
        }
        .number {
          margin-left: 10px;
          font-size: 18px;
        }
        .rank1 {
          color: #ff0000;
        }
        .rank2 {
          color: #ffae00;
        }
        .rank3 {
          color: #02ffa3;
        }
      }
      .dh-item:hover {
        transition: all 0.5s;
        cursor: pointer;
        transform: scale(1.2);
      }
    }
  }
</style>
